import classNames from "classnames"
import { useTableContext } from "./TableContext"
import { CSSProperties, useMemo } from "react"

export const FIRST_COLUMN_FIXED_CLASSES = "left-0 first:sticky first:z-20"
export const FIRST_COLUMN_FIXED_SHADOW_CLASSES =
  "first:after:absolute first:after:bottom-0 first:after:right-0 first:after:top-0 first:after:w-4 first:after:translate-x-full first:after:shadow-[inset_8px_0px_19px_-10px_rgba(0,0,0,.21)]"

export const TWO_COLUMN_FIXED_CLASSES =
  "left-0 first:sticky first:z-20 [&:nth-child(2)]:sticky [&:nth-child(2)]:z-20 [&:nth-child(2)]:left-[var(--first-column-width)]"
export const TWO_COLUMN_FIXED_SHADOW_CLASSES =
  "[&:nth-child(2)]:after:absolute [&:nth-child(2)]:after:bottom-0 [&:nth-child(2)]:after:right-0 [&:nth-child(2)]:after:top-0 [&:nth-child(2)]:after:w-4 [&:nth-child(2)]:after:translate-x-full [&:nth-child(2)]:after:shadow-[inset_8px_0px_19px_-10px_rgba(0,0,0,.21)]"

const END_COLUMN_FIXED_SHADOW_CLASSES =
  "last:after:absolute last:after:bottom-0 last:after:left-0 last:after:top-0 last:after:w-4 last:after:-translate-x-full last:after:shadow-[inset_-10px_0_6px_-10px_rgba(0,0,0,.21)]"
const END_COLUMN_FIXED_CLASSES = "last:sticky last:right-0"

/**
 * @returns fixed columns styles and classNames for table cell elements, depends on table context
 */
export const useFixedColumnsStyles = () => {
  const { fixedStartColumn, isSelectable, isScrollable, firstColumnWidth, fixedEndColumn } =
    useTableContext()

  // By default, the checkbox column is always fixed. Then, the user can specify an extra fixed column with `<Table fixedStartColumn/>`
  const numberOfFixedCols = useMemo(
    () => [fixedStartColumn, isSelectable].filter(boolValue => boolValue).length,
    [fixedStartColumn, isSelectable],
  )

  const className = classNames(
    numberOfFixedCols === 1 && FIRST_COLUMN_FIXED_CLASSES,
    numberOfFixedCols === 1 && isScrollable && FIRST_COLUMN_FIXED_SHADOW_CLASSES,
    numberOfFixedCols === 2 && TWO_COLUMN_FIXED_CLASSES,
    numberOfFixedCols === 2 && isScrollable && TWO_COLUMN_FIXED_SHADOW_CLASSES,

    fixedEndColumn && END_COLUMN_FIXED_CLASSES,
    fixedEndColumn && isScrollable && END_COLUMN_FIXED_SHADOW_CLASSES,
  )

  const style = firstColumnWidth
    ? ({ "--first-column-width": `${firstColumnWidth}px` } as CSSProperties)
    : undefined

  return {
    className,
    style,
  }
}
